import React from 'react';
import { Section } from './ui/Section';
export function SocialProof() {
  const stats = [{
    icon: '👯',
    value: '+5.000',
    label: 'Instructoras en España usando el sistema'
  }, {
    icon: '🏫',
    value: '+800',
    label: 'Academias que lo utilizan actualmente'
  }, {
    icon: '📄',
    value: '+120K',
    label: 'Recursos descargados este año'
  }, {
    icon: '⏰',
    value: '94%',
    label: 'Ahorran +5 horas semanales de planificación'
  }];
  return <Section data-id="element-282">
      <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-283">
        ← Scroll to see full table →
      </div>

      <div className="overflow-x-auto" data-id="element-284">
        <table className="w-full min-w-[600px] border-collapse bg-white rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-285">
          <thead data-id="element-286">
            <tr className="bg-brand-bgAlt border-b border-brand-border" data-id="element-287">
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-288">
                Métrica
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-289">
                Número
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-290">
                Descripción
              </th>
            </tr>
          </thead>
          <tbody data-id="element-291">
            {stats.map((stat, i) => <tr key={i} className="hover:bg-brand-bgAlt transition-colors border-b border-brand-border last:border-0" data-id="element-292">
                <td className="p-3 text-brand-text font-body flex items-center gap-2" data-id="element-293">
                  <span className="text-2xl" data-id="element-294">{stat.icon}</span>
                  <span className="font-semibold" data-id="element-295">
                    Instructoras en la comunidad
                  </span>
                </td>
                <td className="p-3 text-brand-title font-heading font-bold text-xl" data-id="element-296">
                  {stat.value}
                </td>
                <td className="p-3 text-brand-text font-body" data-id="element-297">{stat.label}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Section>;
}